export const SET_TOOL_DETAIL = 'SET_TOOL_DETAIL'
export const SET_ACTIVES = 'SET_ACTIVES'
export const SET_IMAGES = 'SET_IMAGES'
export const DELETE_IMAGE = 'DELETE_IMAGE'
export const REPLACE_ACTIVES = 'REPLACE_ACTIVES'
export const CLEAR_ALL = 'CLEAR_ALL'
export const INIT_LOCAL = 'INIT_LOCAL'

export const SET_EDIT_TOOL = 'SET_EDIT_TOOL'